import './styles/styles.scss'

import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import "./filters/index"
import { createPinia, PiniaVuePlugin } from 'pinia'

/* Vue Bootstrap */
import 'bootstrap/dist/css/bootstrap.min.css'
import "bootstrap"
import 'bootstrap-icons/font/bootstrap-icons.css'
/* Vue Bootstrap */

Vue.use(PiniaVuePlugin)
const pinia = createPinia()

Vue.config.productionTip = false

new Vue({
    vuetify,
    pinia,
    router,
    render: h => h(App)
}).$mount('#app')
